export default {
  title: 'Cláusulas',
  accept: 'Acepto las condiciones',
  key: 'Clave de firma'
}
